import React from 'react';
import { Grid, Paper, FormControlLabel, Switch, Button, TextField, Divider } from '@mui/material';
import { ArrowBackIosOutlined } from '@mui/icons-material';
import SaveIcon from '@mui/icons-material/Save';
import { useWorkflowStyles } from './styles';

interface WorkflowHeaderProps {
  workflowName: string;
  workflowDescription: string;
  enabled: boolean;
  submitDisabled: boolean;
  onNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onEnabledChange: (value: boolean) => void;
  onSave: () => void;
}

const WorkflowHeader: React.FC<WorkflowHeaderProps> = ({
  workflowName,
  workflowDescription,
  enabled,
  submitDisabled,
  onNameChange,
  onDescriptionChange,
  onEnabledChange,
  onSave,
}) => {
  const classes = useWorkflowStyles();

  return (
    <Grid item xs={12}>
      <Paper className={classes.paperContainer}>
        <Grid container justifyContent="space-around">
          <Divider />
          <Grid item xs={10}>
            <FormControlLabel
              control={<Switch checked={enabled} onChange={e => onEnabledChange(e.target.checked)} />}
              label="Active"
            />
          </Grid>
          <Grid item xs={2}>
            <Button
              style={{ float: 'right' }}
              onClick={onSave}
              disabled={submitDisabled}
              startIcon={<SaveIcon />}
              color="primary"
              variant="outlined"
            >
              Save
            </Button>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              label="Name"
              value={workflowName}
              onChange={e => onNameChange(e.target.value)}
              required
              fullWidth
              margin="normal"
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Description"
              value={workflowDescription}
              onChange={e => onDescriptionChange(e.target.value)}
              fullWidth
              margin="normal"
            />
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default WorkflowHeader;
